module.exports = __webpack_public_path__ + "270d3006b4e0a377aa2fdd39afd1b246.png";